import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const keyPrefix = 'detach_department_list';
export const useDetachDepartmentListTranslation = (): UseTranslationResponse<'features', typeof keyPrefix> => {
  return useTranslation('features', { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    title: 'Открепить список от подразделения',
    toast_error: 'Не удалось открепить список от подразделения',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'Detach list from department',
    toast_error: 'Failed to detach list from department',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Desvincular lista del departamento',
    toast_error: 'No se pudo desvincular la lista del departamento',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Desvincular lista do departamento',
    toast_error: 'Não foi possível desvincular a lista do departamento',
  },
}) as Record<string, unknown>;
